import { Modal } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import Styles from "./CreateInventory.module.css";
import cancelIcon from "../../../Assets/cross.png";
import {
  CreateInventoryService,
  createProductListService,
  productListService,
  UpdateInventoryService,
  viewStoreProductService,
} from "../../../Services/ApiServices";
import Loader from "../../../SharedComponents/Loader/Loader";
import { Select } from "antd";
import { useEffect, useState } from "react";
import deleteIcon from "../../../Assets/delete.svg";

export default function CreateInventory(props) {
  const [productList, setProductList] = useState([]);
  const [IsLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [unitList, setUnitList] = useState([]);

  const {
    handleSubmit,
    resetForm,
    handleChange,
    errors,
    values,
    setFieldValue,
    touched,
    isSubmitting,
    setValues,
  } = useFormik({
    initialValues: {
      product_id: "",
      quantity: "",
      min_quantity: "",
      mrp_price: "",
      price: "",
      variant_id: "",
      product_unit: [],
    },
    validationSchema: Yup.object({
      product_id: Yup.string().required("Required"),
      quantity: Yup.string().required("Required"),
      min_quantity: Yup.string().required("Required"),
      mrp_price: Yup.string().required("Required"),
      // price: Yup.string()
      //   .required("Required")
      //   .min(values.mrp_price, "Selling must be Greater than MRP price"),
      price: Yup.string()
        .required("Required")
        .test(
          "is-lesser",
          "Selling price must be less than or equal to MRP price",
          function (value) {
            const { mrp_price } = this.parent;
            return Number(value) <= Number(mrp_price);
          }
        ),
      variant_id:
        unitList?.length > 0
          ? Yup.string().required("Required")
          : Yup.string().optional(),
      // product_unit: Yup.array().of(
      //   Yup.object().shape({
      //     id: Yup.string().required("Required"),
      //     unit: Yup.string().required("Required"),
      //     quantity: Yup.string().required("Required"),
      //     min_quantity: Yup.string().required("Required"),
      //     mrp_price: Yup.string().required("Required"),
      //     selling_price: Yup.string()
      //       .required("Required")
      //       .test(
      //         "is-lesser",
      //         "Selling price must be lesser than or equal to MRP price",
      //         function (value) {
      //           const { mrp_price } = this.parent;
      //           return Number(value) <= Number(mrp_price);
      //         }
      //       ),
      //   })
      // ),
    }),
    onSubmit: (values) => {
      console.log("onsubmit");
      if (props?.editData?.product_id) {
        handleUpdateInventory(values);
      } else {
        handleCreateInventory(values);
      }
    },
  });

  useEffect(() => {
    if (props?.editData?.product_id) {
      handleViewProducts();
    }
  }, [props.editData]);

  const handleViewProducts = () => {
    setIsLoading(true);

    let formData = new FormData();
    formData.append("product_id", props?.editData?.product_id);
    formData.append("franchise_id", props?.profileData?.franchise_id);

    viewStoreProductService(formData)
      .then(({ data }) => {
        if (data?.product_units?.length > 0) {
          setValues({
            ...values,
            product_id: data?.product_id,
            product_unit: data?.product_units?.map((ele) => {
              return {
                id: ele?.id,
                unit: ele?.unit_id,
                quantity: ele?.quantity || 0,
                min_quantity: ele?.min_quantity || 0,
                mrp_price: ele?.franchise_pricing || 0,
                selling_price: ele?.price || 0,
              };
            }),
          });
        } else {
          setValues({
            ...values,
            product_id: data?.product_id,
            quantity: data?.quantity || 0,
            min_quantity: data?.min_quantity || 0,
            mrp_price: data?.mrp_price || 0,
            price: data?.selling_price || 0,
          });
        }

        setProductList([
          {
            label: data?.product_name,
            value: data?.product_id,
          },
        ]);
        // ListProducts(data?.product_name || "");
        setUnitList([...data?.product_units, ...data?.non_units] || []);
      })
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast.error(err.response.data.detail[0].msg);
        } else {
          toast.error("Something went wrong!!");
        }
      })
      .finally(() => setIsLoading(false));
  };

  const handleCreateInventory = (data) => {
    setIsLoading(true);

    let formData = new FormData();

    if (unitList?.length > 0) {
      formData.append("product_id", parseInt(data.product_id));
      if (values?.product_unit?.length > 0) {
        formData.append("product_units", JSON.stringify(values?.product_unit));
      } else {
        formData.append(
          "product_units",
          JSON.stringify([
            {
              id: values?.variant_id,
              unit: unitList?.find((ele) => ele?.id === values.variant_id)
                ?.unit_id,
              quantity: values?.quantity || 0,
              min_quantity: values?.min_quantity || 0,
              mrp_price: values.mrp_price || 0,
              selling_price: values.price || 0,
            },
          ])
        );
      }
    } else {
      formData.append("product_id", parseInt(data.product_id));
      formData.append("quantity", parseInt(data.quantity));
      formData.append("min_quantity", parseInt(data.min_quantity));
      formData.append("mrp_price", parseInt(data.mrp_price));
      formData.append("price", parseInt(data.price));
    }

    const result = {};
    formData.forEach((value, key) => {
      if (result[key]) {
        // It already exists → convert to array
        if (!Array.isArray(result[key])) {
          result[key] = [result[key]];
        }
        result[key].push(value);
      } else {
        result[key] = value;
      }
    });

    CreateInventoryService(formData)
      .then((res) => {
        toast(res?.data?.msg, { type: "success" });
        props.handleTableData(values);
        props.onHide(false);
      })
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast(err.response.data.detail[0].msg, { type: "error" });
        } else {
          toast("Something went wrong!!");
        }
      })
      .finally(() => setIsLoading(false));
  };

  console.log(
    values?.product_unit?.map((ele) => ele?.unit),
    "units"
  );

  const handleUpdateInventory = (data) => {
    setIsLoading(true);

    let formData = new FormData();

    let removedUnits = unitList.filter(
      (ele) => !values?.product_unit?.some((val) => val?.id === ele?.id)
    );

    if (unitList?.length > 0) {
      formData.append("product_id", parseInt(data.product_id));
      formData.append("remove_units", JSON.stringify(removedUnits));

      if (values?.product_unit?.length > 0) {
        formData.append("product_units", JSON.stringify(values?.product_unit));
      } else {
        formData.append(
          "product_units",
          JSON.stringify([
            {
              id: values?.variant_id,
              unit: unitList?.find((ele) => ele?.id === values.variant_id)
                ?.unit_id,
              quantity: values?.quantity,
              min_quantity: values?.min_quantity,
              mrp_price: values.mrp_price,
              selling_price: values.price,
            },
          ])
        );
      }
    } else {
      formData.append("product_id", parseInt(data.product_id));
      formData.append("quantity", parseInt(data.quantity));
      formData.append("min_quantity", parseInt(data.min_quantity));
      formData.append("mrp_price", parseInt(data.mrp_price));
      formData.append("price", parseInt(data.price));
    }

    const result = {};
    formData.forEach((value, key) => {
      if (result[key]) {
        // It already exists → convert to array
        if (!Array.isArray(result[key])) {
          result[key] = [result[key]];
        }
        result[key].push(value);
      } else {
        result[key] = value;
      }
    });

    console.log(result, "resultup");

    UpdateInventoryService(formData)
      .then((res) => {
        toast(res?.data?.msg, { type: "success" });
        props.handleTableData(values);
        props.onHide(false);
      })
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast(err.response.data.detail[0].msg, { type: "error" });
        } else {
          toast("Something went wrong!!");
        }
      })
      .finally(() => setIsLoading(false));
  };

  console.log(values, "formvalues");

  const ListProducts = (value) => {
    console.log(value, "value");

    setIsLoading(true);
    let formData = new FormData();

    formData.append("product_key", value);

    createProductListService(formData, 1, 10)
      .then((res) => {
        console.log(res?.data, "productdata");

        setProductList(
          res?.data?.products
            ?.map((ele) => {
              if (ele?.product_name) {
                return {
                  ...ele,
                  label: ele?.product_name,
                  value: ele?.product_id,
                };
              } else {
                return null;
              }
            })
            .filter((item) => item)
        );
      })
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast.error(err.response.data.detail[0].msg, { type: "error" });
        } else {
          toast.error("Something went wrong!!");
        }
      })
      .finally(() => setIsLoading(false));
  };

  const ValidateProductUnits = () => {
    let productData = values.product_unit.map((ele) => {
      const requiredFields = [
        "quantity",
        "min_quantity",
        "mrp_price",
        "selling_price",
      ];

      let error = false;

      //  Check required fields
      for (let field of requiredFields) {
        if (
          ele[field] === "" ||
          ele[field] === null ||
          ele[field] === undefined
        ) {
          error = true;
          break;
        }
      }

      //  Check selling price > mrp_price
      error =
        !error && Number(ele.selling_price) <= Number(ele.mrp_price)
          ? false
          : true;

      return {
        ...ele,
        error,
      };
    });

    // Update formik value
    setFieldValue("product_unit", productData);

    // check if ANY object has an error
    const hasError = productData.some((item) => {
      console.log(item?.error, "errors");

      return item.error;
    });

    if (!hasError) {
      console.log(hasError, "hasError");

      if (props?.editData?.product_id) {
        handleUpdateInventory(values);
      } else {
        handleCreateInventory(values);
      }
    }
    return !hasError; // true = valid, false = invalid
  };

  return (
    <div className={Styles.parentContainer + " container-fluid"}>
      {isSubmitting && <Loader isLoader={true} />}

      <div className="container">
        <Modal
          size="xl"
          show={props.isOpen}
          onHide={props.onHide}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Body>
            <div className={Styles.cancelImgParentContainer}>
              <div>
                <p className="fontBold">
                  Add Stock <span className="orange">Details</span>
                </p>
              </div>
              <div className={Styles.cancelImgContainer}>
                <img
                  onClick={props.onHide}
                  src={cancelIcon}
                  alt="cancel"
                  className={Styles.cancelImg}
                />
              </div>
            </div>
            <form onSubmit={(e) => e.preventDefault()}>
              <div className={Styles.inputParent}>
                <div className={Styles.leftContainer}>
                  <label className="label">
                    Product Name/Product Code{" "}
                    <span className="text-danger fs-6">*</span>
                  </label>
                  <div id="inventoryselect">
                    {/* <Select
                      id="inventoryselect"
                      getPopupContainer={() =>
                        document.getElementById("inventoryselect")
                      }
                      mode="multiple"
                      allowClear
                      style={{ width: "95%" }}
                      placeholder="Search Product Name"
                      value={values.product_ids}
                      onChange={(val) => {
                        console.log(val, "selectone");
                        setFieldValue("product_ids", val); // ✅ directly set, don't append
                      }}
                      onDeselect={(val) => {
                        console.log(val, "deselectone");
                        const filtered = values.product_ids.filter(
                          (item) => item !== val
                        );
                        setFieldValue("product_ids", filtered);
                      }}
                      options={productList}
                      onSearch={(val) => {
                        setOpen(true); // keep dropdown open while searching
                        ListProducts(val);
                      }}
                      loading={IsLoading}
                      showSearch
                      filterOption={false} // ✅ important: allow remote search
                      onClear={() => setFieldValue("product_ids", [])}
                      open={open}
                      onDropdownVisibleChange={(visible) => setOpen(visible)}
                    /> */}

                    <Select
                      id="inventoryselect"
                      getPopupContainer={() =>
                        document.getElementById("inventoryselect")
                      }
                      size="large"
                      showSearch
                      // allowClear
                      style={{ width: "95%" }}
                      placeholder="Search Product Name/Product Code"
                      value={values.product_id || null}
                      onChange={(val, data) => {
                        // setFieldValue("product_id", val);
                        setValues({
                          ...values,
                          product_id: val,
                          variant_id: "",
                        });
                        console.log(val, data, "val==");
                        setUnitList(data?.product_unit || []);
                      }}
                      options={productList}
                      onSearch={(val) => {
                        // setSearchValue(val);
                        console.log(val, "valus");

                        if (val.trim()) {
                          ListProducts(val); // 🔥 Trigger API immediately while typing
                        }
                        // else {
                        //   setProductList([]);
                        // }
                      }}
                      loading={IsLoading}
                      filterOption={false} // ✅ Important: allow remote filtering
                      // onClear={() => setFieldValue("product_id", "")}
                      // onDropdownVisibleChange={(visible) => setOpen(visible)}
                      disabled={
                        props?.editData?.product_id ||
                        values?.product_unit?.length > 0
                          ? true
                          : false
                      }
                    />
                  </div>
                  {touched.product_id && errors.product_id ? (
                    <div className={Styles.errMsg + " text-danger"}>
                      {errors.product_id}
                    </div>
                  ) : null}
                </div>

                <div className={Styles.leftContainer}>
                  <div className={Styles.unit_container}>
                    <div className={Styles.unit_field}>
                      <label className="label">
                        Unit <span className="text-danger fs-6">*</span>
                      </label>
                      <div id="inventoryselect">
                        <Select
                          id="inventoryselect"
                          getPopupContainer={() =>
                            document.getElementById("inventoryselect")
                          }
                          size="large"
                          allowClear
                          style={{ width: "95%" }}
                          placeholder="Select Unit"
                          value={values.variant_id || null}
                          onChange={(val, data) => {
                            console.log(val, data, "variant");

                            setValues({
                              ...values,
                              quantity: data?.quantity || "",
                              min_quantity: data?.min_quantity || "",
                              price: data?.price || "",
                              mrp_price: data?.franchise_pricing || "",
                              variant_id: val || "",
                            });
                          }}
                          options={unitList?.map((ele) => {
                            return {
                              ...ele,
                              label: ele?.unit_id,
                              value: ele?.id,
                              disabled: values.product_unit?.find((Ele) =>
                                Ele?.unit === ele?.unit_id ? true : false
                              ),
                            };
                          })}
                          // onClear={() => setFieldValue("variant_id", "")}
                          // ⚠️ remove manual `open` control; let AntD handle dropdown state
                          // open={open}
                          // onDropdownVisibleChange={(visible) => setOpen(visible)}
                          disabled={unitList?.length > 0 ? false : true}
                        />
                      </div>
                    </div>
                    {unitList?.length > 0 ? (
                      <div className={Styles.button_container}>
                        <button
                          className={Styles.addbtn}
                          style={{
                            backgroundColor:
                              unitList?.length === values.product_unit?.length
                                ? "#96C491"
                                : "#1c8b03",
                          }}
                          onClick={() => {
                            if (
                              values?.variant_id !== "" &&
                              values?.quantity !== "" &&
                              values?.min_quantity !== "" &&
                              values?.mrp_price !== "" &&
                              values?.price !== ""
                            ) {
                              if (
                                Number(values?.mrp_price) <
                                Number(values?.price)
                              ) {
                                toast.error(
                                  "Selling price must be less than or equal to MRP price"
                                );
                              } else {
                                setValues({
                                  ...values,
                                  product_unit: [
                                    ...(values?.product_unit || []),
                                    {
                                      id: values?.variant_id,
                                      unit: unitList?.find(
                                        (Ele) => values?.variant_id === Ele?.id
                                      )?.unit_id,
                                      quantity: values?.quantity,
                                      min_quantity: values?.min_quantity,
                                      mrp_price: values?.mrp_price,
                                      selling_price: values?.price,
                                    },
                                  ],
                                  variant_id: "",
                                  quantity: "",
                                  min_quantity: "",
                                  mrp_price: "",
                                  price: "",
                                });
                              }
                            } else {
                              toast.success("Enter all the fields");
                            }
                          }}
                          disabled={
                            unitList?.length === values?.product_unit?.length
                          }
                        >
                          Add
                        </button>
                      </div>
                    ) : null}
                  </div>
                  {touched.variant_id && errors.variant_id ? (
                    <div className={Styles.errMsg + " text-danger"}>
                      {errors.variant_id}
                    </div>
                  ) : null}
                </div>
              </div>

              <div className={Styles.inputParent}>
                <div className={Styles.rightContainer}>
                  <label className="label">
                    Quantity <span className="text-danger fs-6">*</span>
                  </label>
                  <div>
                    <input
                      className={Styles.input + " contentFont"}
                      type="text"
                      name="quantity"
                      value={values.quantity}
                      onChange={(e) => {
                        setFieldValue("quantity", e.target.value);
                      }}
                      placeholder="Enter Quantity"
                      // disabled={
                      //   unitList?.length === values?.product_unit?.length
                      // }
                    />
                  </div>
                  {touched.quantity && errors.quantity ? (
                    <div className={Styles.errMsg + " text-danger"}>
                      {errors.quantity}
                    </div>
                  ) : null}
                </div>

                <div className={Styles.leftContainer}>
                  <label className="label">
                    Minimum Order Quantity
                    <span className="text-danger fs-6">*</span>
                  </label>
                  <div>
                    <input
                      className={Styles.input + " contentFont"}
                      type="text"
                      name="min_quantity"
                      onChange={handleChange}
                      value={values.min_quantity}
                      placeholder="Enter Minimum Order Quantity"
                      // disabled={
                      //   unitList?.length === values?.product_unit?.length
                      // }
                    />
                  </div>
                  {touched.min_quantity && errors.min_quantity ? (
                    <div className={Styles.errMsg + " text-danger"}>
                      {errors.min_quantity}
                    </div>
                  ) : null}
                </div>
              </div>

              <div className={Styles.inputParent}>
                <div className={Styles.rightContainer}>
                  <label className="label">
                    MRP <span className="text-danger fs-6">*</span>
                  </label>
                  <div>
                    <input
                      onChange={handleChange}
                      className={Styles.input + " contentFont"}
                      type="text"
                      name="mrp_price"
                      maxLength="10"
                      value={values.mrp_price}
                      placeholder="Enter MRP"
                      onKeyPress={(e) => {
                        if (!(e.key === "0" || parseInt(e.key))) {
                          e.preventDefault();
                        }
                      }}
                      // disabled={
                      //   unitList?.length === values?.product_unit?.length
                      // }
                    />
                  </div>
                  {touched.mrp_price && errors.mrp_price ? (
                    <div className={Styles.errMsg + " text-danger"}>
                      {errors.mrp_price}
                    </div>
                  ) : null}
                </div>
                <div className={Styles.leftContainer}>
                  <label className="label">
                    Selling Price<span className="text-danger fs-6">*</span>
                  </label>
                  <div>
                    <input
                      className={Styles.input + " contentFont"}
                      type="text"
                      name="price"
                      onChange={handleChange}
                      value={values.price}
                      placeholder="Enter Selling Price"
                      // disabled={
                      //   unitList?.length === values?.product_unit?.length
                      // }
                    />
                  </div>
                  {touched.price && errors.price ? (
                    <div className={Styles.errMsg + " text-danger"}>
                      {errors.price}
                    </div>
                  ) : null}
                </div>
              </div>

              {values?.product_unit?.length > 0 ? (
                <div className={Styles.scroll_unit_contianer}>
                  {values?.product_unit?.map((ele, index) => {
                    return (
                      <>
                        <div className={Styles.unitListContainer}>
                          <div className={Styles.unitNameContainer}>
                            <p className={Styles.unitName}>
                              Unit - {ele?.unit}
                            </p>
                            <img
                              src={deleteIcon}
                              alt="del"
                              style={{
                                width: 20,
                                height: 20,
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setFieldValue(
                                  "product_unit",
                                  values?.product_unit?.filter(
                                    (val) => val?.unit !== ele?.unit
                                  )
                                );
                              }}
                            />
                          </div>
                          <div className={Styles.inputParent}>
                            <div className={Styles.rightContainer}>
                              <label className="label">
                                Quantity{" "}
                                <span className="text-danger fs-6">*</span>
                              </label>
                              <div>
                                <input
                                  className={Styles.input + " contentFont"}
                                  type="text"
                                  name="quantity"
                                  value={ele.quantity}
                                  onChange={(val) => {
                                    setFieldValue(
                                      "product_unit",
                                      values.product_unit.map((item, idx) =>
                                        idx === index
                                          ? {
                                              ...item,
                                              quantity: val?.target?.value,
                                            }
                                          : item
                                      )
                                    );
                                  }}
                                  placeholder="Enter Quantity"
                                />
                              </div>
                              {ele?.quantity === "" ||
                              ele?.quantity === undefined ||
                              ele?.quantity === null ? (
                                <div className={Styles.errMsg + " text-danger"}>
                                  Required
                                </div>
                              ) : null}
                            </div>
                            <div className={Styles.rightContainer}>
                              <label className="label">
                                Minimum Order Quantity{" "}
                                <span className="text-danger fs-6">*</span>
                              </label>
                              <div>
                                <input
                                  className={Styles.input + " contentFont"}
                                  type="text"
                                  name="min_quantity"
                                  value={ele.min_quantity}
                                  onChange={(val) => {
                                    setFieldValue(
                                      "product_unit",
                                      values.product_unit.map((item, idx) =>
                                        idx === index
                                          ? {
                                              ...item,
                                              min_quantity: val?.target?.value,
                                            }
                                          : item
                                      )
                                    );
                                  }}
                                  placeholder="Enter Minimum Order Quantity"
                                />
                              </div>
                              {ele?.min_quantity === "" ||
                              ele?.min_quantity === undefined ||
                              ele?.min_quantity === null ? (
                                <div className={Styles.errMsg + " text-danger"}>
                                  Required
                                </div>
                              ) : null}
                            </div>
                            <div className={Styles.rightContainer}>
                              <label className="label">
                                MRP <span className="text-danger fs-6">*</span>
                              </label>
                              <div>
                                <input
                                  className={Styles.input + " contentFont"}
                                  type="text"
                                  name="quantity"
                                  value={ele.mrp_price}
                                  onChange={(val) => {
                                    setFieldValue(
                                      "product_unit",
                                      values.product_unit.map((item, idx) =>
                                        idx === index
                                          ? {
                                              ...item,
                                              mrp_price: val?.target?.value,
                                            }
                                          : item
                                      )
                                    );
                                  }}
                                  placeholder="Enter MRP"
                                />
                              </div>
                              {ele?.mrp_price === "" ||
                              ele?.mrp_price === undefined ||
                              ele?.mrp_price === null ? (
                                <div className={Styles.errMsg + " text-danger"}>
                                  Required
                                </div>
                              ) : null}
                            </div>
                            <div className={Styles.rightContainer}>
                              <label className="label">
                                Selling Price{" "}
                                <span className="text-danger fs-6">*</span>
                              </label>
                              <div>
                                <input
                                  className={Styles.input + " contentFont"}
                                  type="text"
                                  name="quantity"
                                  value={ele.selling_price}
                                  onChange={(val) => {
                                    setFieldValue(
                                      "product_unit",
                                      values.product_unit.map((item, idx) =>
                                        idx === index
                                          ? {
                                              ...item,
                                              selling_price: val?.target?.value,
                                              error:
                                                val?.target?.value <=
                                                ele?.selling_price
                                                  ? false
                                                  : true,
                                            }
                                          : item
                                      )
                                    );
                                  }}
                                  placeholder="Enter Selling Price"
                                />
                              </div>
                              {ele?.selling_price === "" ||
                              ele?.selling_price === undefined ||
                              ele?.selling_price === null ? (
                                <div className={Styles.errMsg + " text-danger"}>
                                  Required
                                </div>
                              ) : Number(ele?.selling_price) <=
                                Number(ele?.mrp_price) ? null : (
                                <div className={Styles.errMsg + " text-danger"}>
                                  Must be less than or equal to MRP price
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  })}
                </div>
              ) : null}

              <div className={Styles.btnContainer}>
                <button
                  onClick={() => {
                    setValues({
                      ...values,
                      quantity: "",
                      min_quantity: "",
                      mrp_price: "",
                      price: "",
                      variant_id: "",
                      product_unit: [],
                    });
                  }}
                  className={Styles.Resetbtn}
                >
                  Reset
                </button>
                <button
                  onClick={() => {
                    if (unitList?.length > 0) {
                      console.log("updatecall");
                      if (
                        unitList?.length > 0 &&
                        values?.product_unit?.length > 0
                      ) {
                        console.log("submit");
                        // handleSubmit();
                        ValidateProductUnits();
                      } else {
                        toast.error("Add product unit");
                      }
                    } else {
                      handleSubmit();
                    }
                  }}
                  className={Styles.btn}
                >
                  Submit
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
}
